import cancelReasonList from "./cancel-reason-list/CancelReasonList.vue";
import i18n from "../../i18n/index";
import CancelReasonsService from "../../services/cancel-reasons/CancelReasonsService";

export default {
    components: {
        cancelReasonList
    },
    data: () => ({
        hideList: false,
        loading: false,
        reasons: [],
        reason: {
            id: null,
            name: '',
            active: ''
        },
        rules: [value => !!value || i18n.t('field-required')],
        loadingDelete: false,
        chkPendingReason: false,
        loadingSaveButton: false,
        showAdd: true,
        showIcon: false,
        showUpdate: false,
        showDelete: false
    }),
    mounted() {},
    methods: {
        handleReason(item) {
            this.hideList = true;
            this.loadingSaveButton = false;
            this.reason.id = item.id;
            this.reason.name = item.name;
            this.chkPendingReason = item.active;
            this.showAdd = false;
            this.showIcon = false;
            this.showUpdate = true;
            this.showDelete = true;
        },
        closeReason() {
            this.hideList = false;
            this.loadingSaveButton = false;
            this.reason = {
                id: null,
                name: '',
                active: ''
            };
            this.$refs.cancelReasonList.getReasons();
            this.showAdd = true;
            this.showUpdate = false;
            this.showIcon = false;
            this.showDelete = false;
        },
        save() {
            if (this.$refs.form.validate()) {
                this.loadingSaveButton = true;
                CancelReasonsService.create(this.reason).then(value => {
                    this.closeReason();
                    this.loadingSaveButton = false;
                }).catch(error => {
                    this.loadingSaveButton = false;
                });
            }
        },
        detelePendingReason() {
            let data = { id: this.reason.id };
            this.loadingDelete = true;
            CancelReasonsService.deletePendingReason(data).then(result => {
                if (result.status == 200) {
                    this.loadingDelete = false;
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: 'Motivo pendiente Eliminado'
                    });
                    this.$refs.cancelReasonList.getReasons();
                    this.closeReason();
                }
            }).catch(error => {
                this.loadingDelete = false;
                this.showIcon = false;
                if (error && error.code) {
                    if (error.code == 'The cancel reason has associated transactions') {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: i18n.t("cancel-reasons-has-transactions")
                        })
                    }
                }
                this.$refs.cancelReasonList.getReasons();
                this.closeReason();
            });
        },
        updatePendingReason() {
            let pendingReasonId = this.reason.id;
            this.reason.active = this.chkPendingReason;
            let data = {
                name: this.reason.name,
                active: this.reason.active == true ? 1 : 0,
            };
            this.loadingSaveButton = true;
            this.showIcon = true;

            CancelReasonsService.updatePendingReason(pendingReasonId, data).then(result => {
                this.loadingSaveButton = false;
                if (result.status == 200 ||  result.status == 201) {
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: "Motivo pendiente Actualizado"
                    });
                    this.$refs.cancelReasonList.getReasons();
                    this.closeReason();
                    this.loadingSaveButton = false;
                }
            }).catch(error => {
                this.loadingSaveButton = false;
                this.showIcon = false;
                if (error && error.code) {
                    if (error.code == 'The cancel reason has associated transactions') {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: i18n.t("cancel-reasons-has-transactions")
                        })
                    }
                }
                this.$refs.cancelReasonList.getReasons();
                this.closeReason();
            });
        }
    }
};
